import React from "react";

import "./DocumentNoteItem.css";

import { Subtitle } from "./../../../StyledComponents";

export default (props) => {
  const Logo = props.Logo;
  return (
    <div
      className="document-note-item__container"
      automationid={`SalesLead_Div_noteItem${props.name}_1`}
      style={{ padding: props.padding ? props.padding : "2rem 4.5rem" }}
    >
      <Logo />
      <Subtitle
        automationid={`SalesLead_h4_noteItem${props.name}_1`}
        aligntext="center"
      >
        {props.title}
      </Subtitle>
    </div>
  );
};
